import { gql } from "@apollo/client";

export const DELETE_CUSTOM_POLICY = gql`
  mutation DeleteCustomPolicy($input: DeleteCustomPolicyInput!) {
    deleteCustomPolicy(input: $input) {
      policyMrn
    }
  }
`;
